import { Copy } from '../copy/Copy';

export const LEADERBOARDS_TABLE_COLUMNS_OVERALL = [
  { id: 'shortName', label: Copy.generate('Tables.labels.name') },
  { id: 'totalDistance', label: Copy.generate('Tables.labels.distance') },
];

export const LEADERBOARDS_TABLE_COLUMNS_WALKING = [
  { id: 'shortName', label: Copy.generate('Tables.labels.name') },
  { id: 'totalWalking', label: Copy.generate('Tables.labels.distance') },
];

export const LEADERBOARDS_TABLE_COLUMNS_RUNNING = [
  { id: 'shortName', label: Copy.generate('Tables.labels.name') },
  { id: 'totalRunning', label: Copy.generate('Tables.labels.distance') },
];

export const LEADERBOARDS_TABLE_COLUMNS_CYCLING = [
  { id: 'shortName', label: Copy.generate('Tables.labels.name') },
  { id: 'totalCycling', label: Copy.generate('Tables.labels.distance') },
];

export const LEADERBOARDS_TABLE_COLUMNS_SWIMMING = [
  { id: 'shortName', label: Copy.generate('Tables.labels.name') },
  { id: 'totalSwimming', label: Copy.generate('Tables.labels.distance') },
];

export const LEADERBOARDS_TABLE_COLUMNS_OTHER = [
  { id: 'shortName', label: Copy.generate('Tables.labels.name') },
  { id: 'totalOther', label: Copy.generate('Tables.labels.distance') },
];
